import React from 'react';
import PropTypes from 'prop-types';
import { Price } from './price';

const COMPONENT_CLASS_NAME = 'price';

/**
 * Some items return a pricelist. If this is the case, we display a "from" price in the PDP/menu item
 * and this component returns the price breakdown.
 *
 * @function
 * @param       {array} priceList priceList array from the API.
 * @constructor
 */
function PriceList({ priceList, depositFee }) {
    if (!priceList || !priceList.length) {
        return null;
    }

    if (priceList && priceList.length > 1) {
        return (
            <table className={COMPONENT_CLASS_NAME}>
                <tbody>
                    {priceList.map(({ price, displayName }, idx) => {
                        return (
                            <tr key={idx}>
                                <th>{displayName}</th>
                                <td>
                                    <Price price={price} naked={true} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return null;
}

PriceList.propTypes = {
    priceList: PropTypes.arrayOf(PropTypes.object),
    depositFee: PropTypes.shape({
        currencyCode: PropTypes.string,
        value: PropTypes.number
    })
};

export { PriceList };
